
import React from 'react';
import StructuredData from '@/components/StructuredData';
import { Site } from '@/services/types';

interface OrganizationSEOSchemaProps {
  sites: Site[];
}

const OrganizationSEOSchema: React.FC<OrganizationSEOSchemaProps> = ({ sites }) => {
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://www.groupefabre-environnement.fr/#organization",
    "name": "Groupe Fabre Environnement",
    "url": "https://www.groupefabre-environnement.fr/",
    "logo": "https://lovable.dev/opengraph-image-p98pqg.png",
    "description": "Spécialiste de la gestion, collecte et valorisation des déchets depuis plus de 25 ans en Occitanie",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Services de gestion des déchets",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Location de bennes",
            "description": "Location de bennes pour tous types de déchets"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Achat de métaux",
            "description": "Rachat de métaux ferreux et non ferreux"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Recyclage et valorisation",
            "description": "Valorisation et recyclage de tous types de déchets"
          }
        }
      ]
    },
    "location": sites.map(site => ({
      "@type": "Place",
      "name": site.name,
      "address": {
        "@type": "PostalAddress",
        "streetAddress": site.address,
        "addressLocality": site.city,
        "postalCode": site.postalCode,
        "addressCountry": "FR"
      },
      "geo": (site.coordinates && site.coordinates.lat && site.coordinates.lng) ? {
        "@type": "GeoCoordinates",
        "latitude": site.coordinates.lat,
        "longitude": site.coordinates.lng
      } : undefined,
      "telephone": site.phone,
      "email": site.email
    }))
  };

  return <StructuredData data={organizationSchema} />;
};

export default OrganizationSEOSchema;
